const successStatusCode = /2../;

export const isSuccessStatusCode = (statusCode: number) => {
    return successStatusCode.test(statusCode.toString());
}